var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sub-visual-full fade text-center color-white",
    style: 'background-image:url(' + _vm.bg + ');'
  }, [_c('div', {
    staticClass: "sub-visual__video-wrap"
  }, [_vm.video ? _c('video', {
    staticClass: "sub-visual__video",
    attrs: {
      "loop": "",
      "autoplay": "",
      "playsinline": "",
      "muted": "",
      "poster": _vm.bg
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.video,
      "type": "video/mp4"
    }
  }), _c('strong', [_vm._v("웹 브라우저가 video를 지원하지 않습니다.")])]) : _vm._e()]), _c('v-container', [_vm._t("default")], 2), _vm.scroll !== 'false' ? _c('scroll-ani') : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }